<template>
  <div
    id="app"
    :class="[
      $router.currentRoute.name + '-page',
      {'ipad-safari' : iPadSafari}
    ]"
  >
    <div 
      class="section-category" 
      v-if="$router.currentRoute.name !== 'login'"
      v-show="$router.currentRoute.name == 'order'"
    >
      <grid/>
      <category-filter/>
    </div>
    <router-view />
    <order-detail v-if="$router.currentRoute.name !== 'login'"/>
    <message-modal v-if="message"/>
    <confirm-modal v-if="confirm"/>
    <input-pad-holder />
    <spinner />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MessageModal from '@/components/MessageModal.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import OrderDetail from '@/components/OrderDetail.vue';
import InputPadHolder from '@/components/InputPadHolder.vue';
import Spinner from '@/components/Spinner.vue';
import SettingService from '@/services/SettingService';
import AuthService from '@/services/AuthService';
import {
  SET_ACTIVE_ELEMENT,
  PURGE_AUTH
} from '@/store/mutation-types';
import CategoryFilter from '@/components/CategoryFilter.vue';
import Grid from '@/components/GridLayout.vue';
export default {
  name: 'App',
  components: {
    MessageModal,
    ConfirmModal,
    OrderDetail,
    InputPadHolder,
    Spinner,
    CategoryFilter,
    Grid,
  },
  computed: {
    token() { return this.getMap('token', true) },
    user() { return this.getMap('user', true) },
    ...mapState({
      message: state => state.toggle.messageModal,
      confirm: state => state.toggle.confirmModal,
      inputHolderFocusing: state => state.inputPad.inputHolderFocusing,
    }),
    iPadSafari() {
      const ua = navigator.userAgent;
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      const webkit = !!ua.match(/WebKit/i);
      return iOS && webkit && !ua.match(/CriOS/i);
    },
    iPadChrome() {
      const ua = navigator.userAgent;
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      const webkit = !!ua.match(/WebKit/i);
      return iOS && webkit && ua.match(/CriOS/i);
    }
  },
  created() {
    let language = localStorage.getItem('pos-language');
    if(language) {
      this.$language.current = language;
    }
  },
  watch: {
    async token(newToken) {
      this.onTokenChanged();
    },
    inputHolderFocusing() {
      window.scrollTo(0, 0);
    },
  },
  async mounted() {
    document.addEventListener('keydown', this.disableKeyDown);
    if (this.$route.name === 'login' && this.token != '') {
      this.onTokenChanged();
    }
    document.addEventListener('click', this.onClick);
    const view = document.querySelector('#app > div:first-child');
    if(view) {
      view.addEventListener('scroll', function() {
        if(this.$store) {
          this.$store.commit(ON_INPUT_PAD_BLUR, true);
        }
      });
    }

    if (!this.user.permissions ||
          this.user.permissions.length == 0) {
      this.$store.commit(PURGE_AUTH);
    }
    
    if(this.iPadChrome) {
      document.body.classList.add('ipad-chrome');
    }
  },
  beforeDestroy() {
    const view = document.querySelector('#app > div:first-child');
    if(view) {
      view.removeEventListener('scroll');
    }
    document.removeEventListener('click', this.onClick);
  },
  methods: {
    disableKeyDown(e) {
      if((e.srcElement.type === 'submit' || e.srcElement.type === 'button' || e.srcElement.tagName === 'BODY') && (e.keyCode === 13 || e.keyCode === 32)) {
        e.preventDefault();
        return false;
      }
    },
    onClick(evt) {
      this.$store.commit(SET_ACTIVE_ELEMENT, evt.target);
    },
    async onTokenChanged() {
      if (this.token === '') {
        this.$router.replace({ name: 'login' });
        return;
      }
    }
  }
};
</script>
